import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteSchedules } from 'src/api/deleteSchedules/deleteSchedules';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from 'src/hooks/QueryKeys';

export const useDeleteSchedules = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (scheduleIds: string[]) => deleteSchedules(scheduleIds),
    onSuccess: () => queryClient.invalidateQueries([getBrandId(), QueryKeys.schedules]),
  });
};
